import { render, staticRenderFns } from "./SynergismRealityButton.vue?vue&type=template&id=47de6ff9&scoped=true&"
import script from "./SynergismRealityButton.vue?vue&type=script&lang=js&"
export * from "./SynergismRealityButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47de6ff9",
  null
  
)

export default component.exports